<nz-card [nzActions]="[actionClose]">    

    <video src="../../../assets/videos/error.mp4" muted autoplay [loop]="true"></video>

    <p class="para" *ngIf="!nzModalData.message">Un errore è stato riscontrato nella procedura! Aspettare qualche minuto e riprovare.</p>
    <p class="para" *ngIf="nzModalData.message" [innerHTML]="nzModalData.message"></p>
</nz-card>
<ng-template #actionClose>
    <a (click)="onClose()" class="home-button" nz-button nzSize="large">Chiudi</a>
</ng-template>